import { render, staticRenderFns } from "./listBoxRight.vue?vue&type=template&id=21667a80&scoped=true&"
import script from "./listBoxRight.vue?vue&type=script&lang=js&"
export * from "./listBoxRight.vue?vue&type=script&lang=js&"
import style0 from "./listBoxRight.vue?vue&type=style&index=0&id=21667a80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21667a80",
  null
  
)

export default component.exports